module.exports = __webpack_public_path__ + "img/11.fb799900.png";